import React from 'react';

function SpeechLanguagePathologyPageSession() {
  return (
    <div className="services-details">
      <div className="container">
        <div className="row">
          <div className="col-xl-4 col-lg-5">
            <div className="services-details__sidebar">
              <div className="services-details__services-list">
                <ul className="services-details__services list-unstyled">
                  <li >
                    <a href="/applied-behavioral-analysis">Applied Behavioral Analysis</a>
                  </li>
                  <li className="active">
                    <a href="/speech-language-pathology">Speech Language Pathology</a>
                  </li>
                  <li>
                    <a href="/occupational-therapy">Occupational Therapy</a>
                  </li>
                  <li>
                    <a href="/special-eduaction">Special Education</a>
                  </li>
                
                </ul>
              </div>
              <div className="banner-one">
                <div 
                  className="banner-one__bg"
                  style={{backgroundImage: "url(assets/images/backgrounds/BG5.png)"}}
                ></div>
                <div className="banner-one__shape-1 float-bob-x">
                  <img src="assets/images/shapes/5.png" alt="" />
                </div>
                <h3 className="banner-one__title">
                  Every child communicates differently
                  <br /> Let's explore how we can support yours -
                  <br /> <b>Contact us</b>
                </h3>
                <div className="banner-one__btn-box">
                  <a href="/contact" className="banner-one__btn thm-btn">Contact Now</a>
                </div>
              </div>
          
            </div>
          </div>
          <div className="col-xl-8 col-lg-7">
            <div className="services-details__right">
              <div className="services-details__img">
                <img src="assets/images/services/Main-(770-377).jpg" alt="" />
              </div>
              <h3 className="services-details__title-1">Speech Language Pathology</h3>
              <p className="services-details__text-1">
              You’ll often find our sessions full of songs, sensory play, movement, and laughter. Each session is tailored to the child’s current communication level, emotional state, and interests—building a foundation of trust before working on expressive and receptive language. Our sessions rarely look like traditional therapy—and that’s intentional. You might see a child spinning with joy, singing a favorite line from a show, exploring textures, or simply sharing space with a therapist in silence. These aren’t detours; they are the work. We follow the child’s lead, tune into their regulation needs, and use play, movement, music, and connection as the foundation for communication. We don’t prompt for performance—we connect for communication.
              </p><br/>
              <div className="services-details__benefit">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="services-details__benefit-img">
                      <img src="assets/images/services/CIRCLE-(369-369).jpg" alt="" />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="services-details__benefit-content">
                      <h3 className="services-details__benefit-title">What We Do</h3>
                      <p style={{ marginTop: '20px' }}>
                      Whether a child is minimally speaking, using echolalia or scripting, communicating through gestures, or is exploring AAC, we meet them with curiosity, respect, and joy. Every child’s way of expressing matters—and we’re here to listen, support, and celebrate it.
                      </p><br/>
                     <p>
                     We support any child who communicates—even if the world hasn’t yet learned to hear them.
                     Whether they're just beginning to express themselves, repeating lines they love, or building their own system of language—we’re here for it. And we’re here for them.
                     </p>
                    </div>
                  </div>
                </div>
              </div>
             
              <section className="team-details">
                <div className="container">
                    <div className="row">
                    <div className="col-xl-2 col-lg-2">
                        <div className="team-details__left">
                        <div className="team-details__img">
                            <img src="assets/images/services/Parent-Partners-(470-587).jpg" alt="" />
                        </div>
                        <div className="team-details__social-box">
                            <div className="team-details__social-title">
                            <p>Parent Partners</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="col-xl-10 col-lg-10">
                        <div className="team-details__right">
                        <h3 className="team-details__title">
                        You are your child’s strongest advocate
                        </h3>
                        <p className="team-details__text">
                        We strongly believe that families are the foundation of a child’s progress. Our therapists provide hands-on coaching, customized home programs, and regular updates to ensure that communication goals are supported beyond the therapy room. We see you as the expert on your child. You know their joys, their struggles, their quirks, and their spark. That’s why we value working <i>with</i> you, not just <i>for</i> you. When we combine your deep understanding of your child with our clinical expertise, incredible things happen.
                        </p>
                        </div>
                    </div>
                    <p>Therefore, at the heart of our Speech and Language Therapy program is a strong belief: parents are not just part of the process — they are essential to it.</p>
                    </div>
                </div>
            </section>
              <br/>
            </div>
          </div>
          
          <div className="container">
                    <div className="row">
                    <div className="col-xl-4">
                        <div className="why-choose-one__left">
                        <div className="section-title text-left">
                            <span className="section-title__tagline">Knowing us</span>
                            <h2 className="section-title__title">
                            Why choose <br/> us?
                            </h2>
                        </div>
                        </div>
                    </div>
                    <div className="col-xl-8">
                        <div className="why-choose-one__right">
                        <ul className="why-choose-one__list list-unstyled">
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                               <img src="assets/images/icons/Comprehensive.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Comprehensive Assessment & Parent Consultation
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                 <img src="assets/images/icons/Individualised.png" alt="Service Icon" />

                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Individualized Goal Setting & Therapy Planning
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                <img src="assets/images/icons/Play-based.png" alt="Service Icon" />

                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Play-Based, Child-Led Therapy Sessions
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                 <img src="assets/images/icons/Family.png" alt="Service Icon" />

                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Family Involvement & Home Support
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                  <img src="assets/images/icons/Ongoing.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Ongoing Progress Monitoring
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                <img src="assets/images/icons/Transition.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Transition Planning
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                        </ul>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="services-details__book">
                <div className="services-details__book-img">
                  <img src="assets/images/shapes/277-235.jpg" alt="" />
                </div>
                <div className="services-details__book-shape-1">
                  <img src="assets/images/shapes/services-details-book-shape-1.png" alt="" />
                </div>
                <div className="services-details__book-top">
                  <div className="icon">
                    <span className="icon-phone-call"></span>
                  </div>
                  <div className="content">
                    <p>Have Questions?</p>
                    
                  </div>
                </div>
                <div className="services-details__book-title-and-btn">
                  <h3 className="services-details__book-title">
                  Curious to know more?
                    <br /> We're just a call away — <b>Contact us.</b>
                  </h3>
                  <div className="services-details__book-btn-box">
                    <a href="/contact" className="services-details__book-btn thm-btn">
                      Contact Now
                    </a>
                  </div>
                </div>
              </div>


        </div>
      </div>
    </div>
  );
}

export default SpeechLanguagePathologyPageSession;